// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__XxPrk","pink":"About_pink__nMS8R","green":"About_green__uq4yf","skills":"About_skills__vZcym"};